'use client';

import { motion } from 'motion/react';

import { DURATION } from '@/constants/animations';

import SpinnerLoader from './SpinnerLoader';

type LoadingOverlayProps = {
  size?: number;
  className?: string;
};

export default function LoadingOverlay({ size = 40, className = 'text-primary' }: LoadingOverlayProps) {
  return (
    <motion.div
      className="absolute inset-0 z-10 flex items-center justify-center rounded-lg bg-white/70"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: DURATION.medium }}
      aria-live="polite"
      aria-busy="true"
    >
      <div className="flex flex-col items-center space-y-2">
        <SpinnerLoader size={size} className={className} />
      </div>
    </motion.div>
  );
}
